import { Grid, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TransitGroup } from '@e-origin/shared';

import { TextInput } from '@components';
import { getAmendmentType } from '../../../../utils';
import { TransitAutocompleteHeader } from '../../TransitAutocompleteHeader';
import { TransitInputHeader } from '../../TransitInputHeader';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { TransitViewEditHouseFormValues } from './validateTransitViewEditHouseForm';

interface HouseConsignmentDataProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  houseForm: UseFormReturnType<TransitViewEditHouseFormValues>;
  disabled: boolean;
  editDisabledConditionalForArrival: boolean;
}

export const HouseConsignmentData: React.FC<HouseConsignmentDataProps> = (props) => {
  const { form, houseForm, disabled, editDisabledConditionalForArrival } = props;
  const isArrival = form?.values?.generalInfo?.group === TransitGroup.ARRIVAL;
  const { isGeneralAmendment } = getAmendmentType(form.values.TransitOperation.amendment);

  return (
    <Stack mt="md">
      <Grid>
        {!isArrival && (
          <Grid.Col span={3}>
            <TransitAutocompleteHeader
              form={houseForm}
              parents={[form?.values?.Consignment?.countryOfDispatch]}
              name="countryOfDispatch"
              disabled={disabled || isGeneralAmendment}
              placeholder="Country Of Dispatch"
              code="CL008"
            />
          </Grid.Col>
        )}

        <Grid.Col span={4}>
          <TransitAutocompleteHeader
            form={houseForm}
            parents={[form?.values?.Consignment?.countryOfDestination]}
            name="countryOfDestination"
            disabled={disabled || isGeneralAmendment}
            placeholder="Country Of Destination"
            code="CL008"
          />
        </Grid.Col>
        <Grid.Col span={2}>
          <TextInput
            {...houseForm.getInputProps('grossMass')}
            label="Gross Mass"
            disabled={disabled || isGeneralAmendment || editDisabledConditionalForArrival}
          />
        </Grid.Col>
        {!isArrival && (
          <Grid.Col span={3}>
            <TransitInputHeader
              form={houseForm}
              parents={[form?.values?.Consignment?.referenceNumberUCR]}
              name="referenceNumberUCR"
              disabled={disabled || isGeneralAmendment}
              label="Reference Number UCR"
            />
          </Grid.Col>
        )}
      </Grid>
    </Stack>
  );
};
